import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { TransactionHistoryListPage } from "@/modules/order";
import { requireAuthAndPermission } from "@/utils";

const transactionHistorySearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(z.enum(["newest", "oldest"]), "newest").default("newest")
});

export const Route = createFileRoute("/transaction-history/")({
  validateSearch: zodValidator(transactionHistorySearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Transaction History"
        description="View your transaction history and payment records."
      />
      <TransactionHistoryListPage />
    </>
  )
});

export type TransactionHistorySearchSchema = z.infer<
  typeof transactionHistorySearchSchema
>;
